import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=2b01793c&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=2b01793c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01793c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b01793c')) {
      api.createRecord('2b01793c', component.options)
    } else {
      api.reload('2b01793c', component.options)
    }
    module.hot.accept("./op-detail.vue?vue&type=template&id=2b01793c&scoped=true", function () {
      api.rerender('2b01793c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/salesman/dialog/op-detail.vue"
export default component.exports